import { render, staticRenderFns } from "./RegistroB2Badmin.vue?vue&type=template&id=15f6b8c8&scoped=true&"
import script from "./RegistroB2Badmin.vue?vue&type=script&lang=js&"
export * from "./RegistroB2Badmin.vue?vue&type=script&lang=js&"
import style0 from "./RegistroB2Badmin.vue?vue&type=style&index=0&id=15f6b8c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f6b8c8",
  null
  
)

export default component.exports